import { CHCHeadingList } from "./heading-list.component.js";
customElements.define("chc-heading-list", CHCHeadingList);
export {
  CHCHeadingList
};
//# sourceMappingURL=heading-list.js.map
